import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiConfigs } from "../../constants/apiConfigs"
import { ERROR } from "../../constants/errors";
import { fetchCollaborationPermalinkFile } from "../../services/api/collaboration";

export interface PermalinkFilesSlice {
    loading: boolean,
    error: string | null,
    files: Record<string, Record<string, {
        url: string
    }>>
} 

const initialState: PermalinkFilesSlice = {
    loading: true,
    error: null,
    files: {}
}

const STALE_TIME = apiConfigs.FETCH_COLLABORATION_PERMALINK_FILE.staleTime;

export const fetchPermalinkFile = createAsyncThunk(
    'collaboration/permalink-file',
    async ({campaignId, permalink}: {campaignId: string, permalink: string}, {getState, rejectWithValue}) => {
        const state = getState() as {permalinkFiles: PermalinkFilesSlice};
        if(state.permalinkFiles.files[campaignId]?.[permalink]){
            return {permalink, file: state.permalinkFiles.files[campaignId][permalink], campaignId};
        }
        try {
            const file = await fetchCollaborationPermalinkFile(campaignId, permalink);
            return {permalink, file, campaignId};
        } catch (error) {
            return rejectWithValue(ERROR.NOT_FOUND);
        }
    }
)

const permalinkFiles = createSlice({
    name: 'permalinkFiles',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchPermalinkFile.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchPermalinkFile.rejected, (state) => {
            state.loading = false;
        })
        .addCase(fetchPermalinkFile.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;

            const {campaignId, permalink, file} = action.payload;

            state.files[campaignId] = {
                ...(state.files[campaignId] ?? {}),
                [permalink]: file
            }
        })
    }
})

export default permalinkFiles.reducer